import deleteEmptyElementsInObjectRecursive from "../../functions/deleteEmptyJsonElements";
import updateFhirJson from "../../functions/updateFhirJsonAPI";
import { changesCleared } from "../../slices/changedResourcesList/changedResourcesListSlice";

const saveAllChanges = async (foi, apiToken, connectionId, parentResourceDetail, resourceCollection,
    changedResourcesList, dispatch, setParentResourceAlertModalState = undefined) => {
    console.log("saveAllChanges ---------------------------")
    const filteredResourceCollection = resourceCollection.filter(entry => changedResourcesList.includes(entry.id));
    let primaryEntryUpdated;
    for (const entry of filteredResourceCollection) {
        let entryFoi = entry.id;
        if (entryFoi === foi) {
            primaryEntryUpdated = entry;
        } else {
            let resourceJson = JSON.parse(JSON.stringify(entry.revisedResourceJson));
            let title = entry.displayTitle;
            deleteEmptyElementsInObjectRecursive(resourceJson);
            console.log("updating server for " + entryFoi)
            await updateFhirJson(entryFoi, resourceJson, title, apiToken, connectionId);
        }
    }
    let resourceJson;
    let title;
    if (primaryEntryUpdated) {
        resourceJson = primaryEntryUpdated.revisedResourceJson;
        title = primaryEntryUpdated.displayTitle;
    } else { //TODO -- determine when this else occurs, and if updateFhirJson and setParentResourceAlertModalState are desired in this instance
        resourceJson = parentResourceDetail.revisedResourceJson;
        title = parentResourceDetail.displayTitle;
    }
    let trimmedResourceJson = deleteEmptyElementsInObjectRecursive(JSON.parse(JSON.stringify(resourceJson)));
    let response = await updateFhirJson(foi, trimmedResourceJson, title, apiToken, connectionId, undefined, null, null, setParentResourceAlertModalState !== undefined);
    if (response?.success) {
        if (response.parentResourcesToBeAlertedTo?.length && setParentResourceAlertModalState) {
            setParentResourceAlertModalState(prevState => {
                return {
                    ...prevState,
                    modalOpen: true,
                    parentResourcesToBeAlertedTo: response.parentResourcesToBeAlertedTo
                };
            });
        }
        dispatch(changesCleared());
        return "successful";
    }
}

export default saveAllChanges;